/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_ContextInputs */

const en_wb_sales_context = /** @type {(inputs: Wb_Sales_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New business enquiry`)
};

const lv_wb_sales_context = /** @type {(inputs: Wb_Sales_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauns biznesa pieprasījums`)
};

/**
* | output |
* | --- |
* | "New business enquiry" |
*
* @param {Wb_Sales_ContextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_context = /** @type {((inputs?: Wb_Sales_ContextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_ContextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_context(inputs)
	return en_wb_sales_context(inputs)
});